import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {RequestApiService} from "../../../services/domain_code/request-api.service";
import {BehaviorSubject, Subject, Subscription} from "rxjs";
import {ReleaseOrderService} from "../../../services/release-order.service";
import {IRequestModel} from "../../../components/external-dashboards/my-orders-table/new-request.model";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiRoutes} from "../../../services/apiroutes";
import {ReleaseOrderComponent} from "../../../components/external-dashboards/release-order/release-order.component";
import {ReturnOrderComponent} from "../../../components/external-dashboards/return-order/return-order.component";
import {DepotFormComponent} from "../../../components/external-dashboards/depot-form/depot-form.component";
import {
    MyOrdersTableComponent
} from "../../../components/external-dashboards/my-orders-table/my-orders-table.component";
import {InfoContentComponent} from "../../../components/external-dashboards/info-content/info-content.component";
import {
    LeaseQuoteTableComponent
} from "../../../components/external-dashboards/quoteTable/lease-quote-table/lease-quote-table.component";
import {AckRequestService} from "../../../services/ack-request.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../services/auth.service";
import {ChatService} from "../../../services/chat.service";
import {MatTableDataSource} from "@angular/material/table";
import {ReturnDetails} from "../../../models/return-container-reference";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {LiveAnnouncer} from "@angular/cdk/a11y";
import {ReturnContainersService} from "../../../services/return-containers.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {WarningBoxComponent} from 'src/app/components';

@Component({
    selector: 'logzy-ops-date-change-request-details',
    templateUrl: './ops-date-change-request-details.component.html',
    styleUrls: ['./ops-date-change-request-details.component.scss']
})
export class OpsDateChangeRequestDetailsComponent implements OnInit {
    externalAppUrl = 'invoice/list'
    readTrigger: Subscription;
    request: string;
    request_url = `${ApiRoutes.LeadRequest}request_details/`;
    reviewQuoteData = null;
    request_id = '';
    previousMenu: string = null;
    requestError: boolean;

    locationSourceLabel: string;
    locationDestinationLabel: string;
    review: boolean = false;
    reviewLease: boolean = false;
    @Input()
    refreshRequestDetails = new BehaviorSubject(null);

    quoteList = [];

    _possibleStatusChangeList = [];
    @Input() possibleButtonStatuses = [];
    possibleQuickActionStatuses = [];
    newNotificationFlag: boolean = false;
    loadCommercials: boolean = false;
    timeoutId: ReturnType<typeof setTimeout>;
    rowId: string = '';
    firstSlab: string = '';
    secondSlab: string = '';

    get possibleStatusChangeList() {
        return this._possibleStatusChangeList;
    }

    set possibleStatusChangeList(value) {
        this._possibleStatusChangeList = value;
        this.possibleButtonStatuses = this._possibleStatusChangeList.filter(
            (item) =>
                (this.authService.isCustomer() && item.enable_quick_action_button_for_external) ||
                ((!this.authService.isCustomer()) && item.enable_quick_action_button_for_internal)
        );
        this.possibleQuickActionStatuses = this._possibleStatusChangeList.filter(
            (item) =>
                (this.authService.isCustomer() && item.enable_quick_action_link_for_external) ||
                ((!this.authService.isCustomer()) && item.enable_quick_action_link_for_internal)
        );
    }

    negotiate: boolean = true;
    // skipFeedback: boolean = false;
    addRelease: boolean = false;
    addReturn: boolean = false;
    addReexport: boolean = false;
    addMovementDetails: boolean = false;
    viewDetails: boolean = true;
    attention: boolean = true;
    secondaryButton: boolean = true;
    ternaryButton: boolean = true;
    loader: boolean = true;
    celebrate: boolean = false;
    expand: boolean = false;
    action_message: string = "You have got the best rate for the trade lane and equipment selected. Please hurry and accept the Quotation.";
    action1: string = "Negotiate";
    action2: string = "Accept Quote";
    timelineAction1: string = "Collapse";
    unit: number = 12;
    @Output() closeview = new EventEmitter<boolean>();
    @Output() editRequestAndRequirement = new EventEmitter<any>();
    @Output() editLeadRequest = new EventEmitter<any>();
    @Output() editRO = new EventEmitter<any>();
    @Output() nudge = new EventEmitter<any>();
    @Output() cancelReleaseOrder = new EventEmitter<any>();
    @Output() revalidate = new EventEmitter<any>();
    @Output() custrevalidate = new EventEmitter<any>();
    @Output() editPickupS = new EventEmitter<any>();
    @Output() editDropoffS = new EventEmitter<any>();

    @Output() editROrder = new EventEmitter<any>();
    @Output() cancelROrder = new EventEmitter<any>();
    @Output() revalidateROrder = new EventEmitter<any>();
    @Output() custrevalidateROrder = new EventEmitter<any>();

    @Output() depotForm = new EventEmitter<any>();
    @Output() filterForm = new EventEmitter<any>();
    @Output() containerListRO = new EventEmitter<any>();


    @ViewChild(ReleaseOrderComponent) child: ReleaseOrderComponent;
    @ViewChild(ReturnOrderComponent) child1: ReturnOrderComponent;
    @ViewChild(DepotFormComponent) child2: DepotFormComponent;
    @ViewChild(MyOrdersTableComponent) child3: MyOrdersTableComponent;
    @ViewChild(InfoContentComponent) child4: InfoContentComponent;
    @ViewChild(LeaseQuoteTableComponent) leaseQuoteTable: LeaseQuoteTableComponent;

    refreshTable = new Subject();
    requestDetails: IRequestModel;
    mode: string = '';

    dataSource = new MatTableDataSource<ReturnDetails>();

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    displayedColumns: string[] = [];

    billuLoader: boolean = true;
    billuLoader1: boolean = true;
    loading: boolean = true;
    update: boolean = false;
    part1: string = 'Just';
    part2: string = 'Checking';
    part3: string = 'data';
    containerDetails: ReturnDetails[];
    pageLength = 0;
    submitted = false;
    pageSize = 10;
    pageIndex = 0;

    editActionList: any[] = [
        {
            value: 1,
            display_name: 'Edit Pick-Up'
        },
        {
            value: 2,
            display_name: 'Edit Drop-Off',
        },
        {
            value: 3,
            display_name: 'Edit Both',
        }
    ];

    editAction: number = 3;
    rType: string = '';
    type: string = '';
    documents;
    disableSaveButton: boolean = false;
    storageTotal = 0;
    storageTotalUpdated: number = 0;
    storageCurrency: string = '';
    perDiemTotal = 0;
    perDiemTotalUpdated: number = 0;
    perDiemCurrency: string = '';
    remarks: string = '';
    searchText: string = '';

    closeView() {
        this.router.navigateByUrl(`/ops-date-change`);
    }

    constructor(public requestService: RequestApiService,
                private route: ActivatedRoute,
                private ackRequest: AckRequestService,
                private router: Router,
                private dialog: MatDialog,
                public authService: AuthService,
                public releaseservice: ReleaseOrderService,
                public chatService: ChatService,
                private _liveAnnouncer: LiveAnnouncer,
                private returnContainerService: ReturnContainersService,
                private snackBar: MatSnackBar) {
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.getNotificationMessages();
        }, 5000);

        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.request_id = params['id'];
                this.getRequestDetailsById(params['id']);
                this.negotiate = true;
            }

            if ('rtype' in params) {
                this.rType = params['rtype'];
            }

            if ('type' in params) {
                this.type = params['type'];
            }
        });

        this.displayedColumns = [
            'container_number',
            'pickup_date',
            'pickup_depot',
            'dropoff_date',
            'dropoff_depot',
            'storage_charged_from',
            'free_days',
            'extra_storage_days',
            'extra_usage_days',
            'storage_charge',
            'per_diem'
        ];

    }

    getContainerDetails() {
        this.returnContainerService
            .getPickupDropoffContainerDetails(this.request_id)
            .subscribe((res) => {
                this.containerDetails = res;
                this.containerDetails.map((container: any) => {
                    this.quoteResponse.quote_items.map((quote: any) => {
                        if (quote.requirement == container.do_requirement) {
                            container.quote = quote;
                            container.pickupDateChanged = false;
                            container.dropoffDateChanged = false;
                            this.calculateInitialValues(container);
                        }
                    })
                })
                this.containerDetails = this.containerDetails.map(element => ({
                    ...element,
                    original_pickup_date: new Date(element.pickup_date), // Store the original pickup date
                    original_drop_off_date: new Date(element.return_container_reference.dropoff_date), // Store the original drop off date

                }));
                this.dataSource = new MatTableDataSource<ReturnDetails>(
                    this.containerDetails
                );

                this.calculateTotal();
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.pageLength = res.length;

                if (this.pageLength > 0) {
                    console.log(this.pageLength > 0, 'this.pageLength > 0');
                    this.billuLoader = false;
                    this.loading = false;
                    this.update = false;
                }
                if (this.pageLength === 0) {
                    console.log(this.pageLength === 0, 'this.pageLength === 0');
                    this.part1 = 'No';
                    this.part2 = 'Returns';
                    this.part3 = 'yet';
                    this.loading = false;
                    this.update = false;
                }
            });
    }

    getNotificationMessages() {
        this.chatService.wsSubject$
            .subscribe({
                next: (msg) => {
                    console.log('new_chat_message ------------->', msg);
                    if (msg.event == 'init_connection') {
                        this.chatService.wsSubject$.subscribe();
                        // console.log(this.newChat);
                        // this.chatService.wsSubject$.next(this.newChat);
                    } else if (msg.event == 'new_chat_message') {
                        this.newNotificationFlag = true;
                        let audio = new Audio();
                        audio.src = "assets/audio/notification.mp3";
                        audio.load();
                        audio.play();
                    }
                    // console.log(this.newNotifications);
                },
                error: (err) => {
                    console.log(err);
                },
                complete: () => {
                    console.log(
                        'Notifications Socket Disconnected ...............'
                    );
                },
            });
    }

    default_currency: any;

    getRequestDetailsById(id) {
        console.log('Getting request details');
        if (id == null) {
            return;
        }
        this.requestService.getRequestDetailsById(id).subscribe({
            next: response => {
                this.requestDetails = response;
                this.requestService.selectedRequest = {...response};
                this.ackRequest.selectedRequest = {...response};
                this.getQuotes(this.requestService.selectedRequest);

                this.externalAppUrl = `invoice/list/&sub_booking=${this.requestDetails?.arthakosh_id}`
                this.requestError = false;
                return response;
            },
            error: error => {
                if (error.status > 399 && error.status < 499) {
                    this.requestError = true;
                }
                return error;
            }
        })
    }

    quoteResponse: any;

    // GET quotes for requirements
    getQuotes(request) {
        this.requestService.getBaseQuote(request).subscribe({
            next: response => {
                this.quoteResponse = response;
                this.getContainerDetails();
                return response;
            },
            error: error => {
                return error;
            }
        });
    }

    sortData(sortState: Sort) {
        this.update = true;
        if (sortState.direction) {
            this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
            this.update = false;
        } else {
            this._liveAnnouncer.announce('Sorting cleared');
            this.update = false;
        }
    }

    resetTable() {
        if (this.editAction == 1) {
            this.displayedColumns = [
                'container_number',
                'pickup_date',
                'pickup_depot',
                'storage_charged_from',
                'extra_storage_days',
                'storage_charge',
            ];
        } else if (this.editAction == 2) {
            this.displayedColumns = [
                'container_number',
                'pickup_depot',
                'dropoff_date',
                'dropoff_depot',
                'free_days',
                'extra_usage_days',
                'per_diem'
            ];
        } else {
            this.displayedColumns = [
                'container_number',
                'pickup_date',
                'pickup_depot',
                'dropoff_date',
                'dropoff_depot',
                'storage_charged_from',
                'free_days',
                'extra_storage_days',
                'extra_usage_days',
                'storage_charge',
                'per_diem'
            ];
        }
    }

    updatePickupData(row: any) {
        row.pickupDateChanged = true;
        this.calculateValues(row);
    }

    updateDropoffData(row: any) {
        row.dropoffDateChanged = true;
        this.calculateValues(row);
    }

    calculateInitialValues(container: any) {
        let currentDate = new Date().setDate(new Date().getDate() - 1);
        const oneDay = 24 * 60 * 60 * 1000;
        const validTillDate: any = new Date(container.do?.valid_till);
        const initialValidityDate: any = new Date(container.do?.initial_validity_date);
        // const diffTime = validTillDate.getTime() - initialValidityDate.getTime();
        // const diffDays = Math.round(Math.abs(diffTime / oneDay));

        container.storage_charged_from = container.do?.initial_validity_date != null ? initialValidityDate : validTillDate;

        if (this.rType == 'one_way') {
            container.free_days_min = container.quote?.min_free_days;
            container.free_days_min_updated = container.quote?.min_free_days;
            container.free_days_max = container.quote?.max_free_days;
            container.free_days_max_updated = container.quote?.max_free_days;
        } else if (this.rType == 'lease') {
            container.free_days_min = container.quote?.build_up_period_days;
            container.free_days_min_updated = container.quote?.build_up_period_days;
            container.free_days_max = container.quote?.build_down_period_days;
            container.free_days_max_updated = container.quote?.build_down_period_days;
        } else {
            container.free_days_min = 0;
            container.free_days_min_updated = 0;
            container.free_days_max = 0;
            container.free_days_max_updated = 0;
        }

        const pickUpDate: any = new Date(container.pickup_date);
        const dropOffDate: any = container.return_container_reference?.dropoff_date != null ? new Date(container.return_container_reference?.dropoff_date) : new Date(currentDate);

        const extraStorageTime = pickUpDate.getTime() - (container.do?.initial_validity_date != null ? new Date(container.do?.initial_validity_date).getTime() : validTillDate.getTime());
        const extraStorageDays = Math.round(Math.abs(extraStorageTime / oneDay));
        container.extra_storage_days = extraStorageTime < 0 ? 0 : extraStorageDays;
        container.extra_storage_days_updated = extraStorageTime < 0 ? 0 : extraStorageDays;

        const extraUsageTime = dropOffDate.getTime() - pickUpDate.getTime();
        const extraUsageDays = Math.round(Math.abs(extraUsageTime / oneDay));

        if (this.rType == 'one_way') {
            container.extra_usage_days = extraUsageTime < 0 ? 0 : (extraUsageDays > container.free_days_min ? extraUsageDays - container.free_days_min : 0);
            container.extra_usage_days_updated = extraUsageTime < 0 ? 0 : (extraUsageDays > container.free_days_min ? extraUsageDays - container.free_days_min : 0);
        } else if (this.rType == 'lease') {
            container.extra_usage_days = extraUsageTime < 0 ? 0 : extraUsageDays > container.free_storage_days ? (extraUsageDays - (container.free_storage_days ? container.free_storage_days : 0)) : 0;
            container.extra_usage_days_updated = extraUsageTime < 0 ? 0 : extraUsageDays > container.free_storage_days ? (extraUsageDays - (container.free_storage_days ? container.free_storage_days : 0)) : 0;
        } else {
            container.extra_usage_days = 0;
            container.extra_usage_days_updated = 0
        }

        container.storage_charge = container.do?.storage_charge * container.extra_storage_days;
        container.storage_charge_currency = container.do?.storage_charge_currency;
        container.storage_charge_updated = container.do?.storage_charge * container.extra_storage_days;

        const perDiemTime = dropOffDate.getTime() - pickUpDate.getTime();
        const totalUsageDays = Math.round(Math.abs(perDiemTime / oneDay));

        if (this.rType == 'one_way') {
            const minFreeDays = container?.quote?.min_free_days;
            const minPerDiem = container?.quote?.min_per_diem;
            const maxFreeDays = container?.quote?.max_free_days;
            const maxPerDiem = container?.quote?.max_per_diem;

            if (totalUsageDays < minFreeDays) {
                container.per_diem = 0;
                container.per_diem_updated = 0;
            } else if ((minFreeDays < totalUsageDays) && (totalUsageDays < maxFreeDays)) {
                const minExtraDays = totalUsageDays - minFreeDays;
                container.per_diem = Number(minExtraDays) * Number(minPerDiem);
                container.per_diem_updated = Number(minExtraDays) * Number(minPerDiem);
            } else if (totalUsageDays > maxFreeDays) {
                const maxExtraDays = totalUsageDays - maxFreeDays;
                const minExtraDays = maxFreeDays - minFreeDays;
                const maxPerDiemAmount = Number(maxExtraDays) * Number(maxPerDiem);
                const minPerDiemAmount = Number(minExtraDays) * Number(minPerDiem);
                container.per_diem = Number(maxPerDiemAmount) + Number(minPerDiemAmount);
                container.per_diem_updated = Number(maxPerDiemAmount) + Number(minPerDiemAmount);
            }
            container.per_diem_currency = container?.quote?.min_per_diem_currency;
        } else if (this.rType == 'lease') {
            const minPerDiem = container?.quote?.per_diem_charge;
            const maxFreeDays = container?.quote?.build_down_period_days;
            const maxPerDiem = container?.quote?.post_build_down_per_diem_charge;
            const leasingPeriodDays = container?.quote?.leasing_period_days;

            if (totalUsageDays <= leasingPeriodDays) {
                container.per_diem = Number(totalUsageDays) * Number(minPerDiem);
                container.per_diem_updated = Number(totalUsageDays) * Number(minPerDiem);
            } else if (totalUsageDays <= (leasingPeriodDays + maxFreeDays)) {
                container.per_diem = Number(totalUsageDays) * Number(minPerDiem);
                container.per_diem_updated = Number(totalUsageDays) * Number(minPerDiem);
            } else if (totalUsageDays > (leasingPeriodDays + maxFreeDays)) {
                container.per_diem = Number(totalUsageDays) * Number(maxPerDiem);
                container.per_diem_updated = Number(totalUsageDays) * Number(maxPerDiem);
            }
            container.per_diem_currency = container?.quote?.per_diem_charge_currency;
        } else {
            container.per_diem = 0;
            container.per_diem_updated = 0
        }
    }

    calculateValues(container: any) {
        let currentDate = new Date().setDate(new Date().getDate() - 1);
        const oneDay = 24 * 60 * 60 * 1000;
        const validTillDate: any = new Date(container.do?.valid_till);
        const initialValidityDate: any = new Date(container.do?.initial_validity_date);
        // const diffTime = validTillDate.getTime() - initialValidityDate.getTime();
        // const diffDays = Math.round(Math.abs(diffTime / oneDay));

        container.storage_charged_from = container.do?.initial_validity_date != null ? initialValidityDate.getTime() : validTillDate.getTime();

        if (this.rType == 'one_way') {
            container.free_days_min_updated = container.quote?.min_free_days;
            container.free_days_max_updated = container.quote?.max_free_days;
        } else if (this.rType == 'lease') {
            container.free_days_min_updated = container.quote?.build_up_period_days;
            container.free_days_max_updated = container.quote?.build_down_period_days;
        } else {
            container.free_days_min_updated = 0;
            container.free_days_max_updated = 0;
        }

        const pickUpDate: any = new Date(container.pickup_date);
        const dropOffDate: any = container.return_container_reference?.dropoff_date != null ? new Date(container.return_container_reference?.dropoff_date) : new Date(currentDate);

        const extraStorageTime = pickUpDate.getTime() - (container.do?.initial_validity_date != null ? new Date(container.do?.initial_validity_date).getTime() : validTillDate.getTime());
        const extraStorageDays = Math.round(Math.abs(extraStorageTime / oneDay));
        container.extra_storage_days_updated = extraStorageTime < 0 ? 0 : extraStorageDays;

        const extraUsageTime = dropOffDate.getTime() - pickUpDate.getTime();
        const extraUsageDays = Math.round(Math.abs(extraUsageTime / oneDay));

        if (this.rType == 'one_way') {
            container.extra_usage_days_updated = extraUsageTime < 0 ? 0 : (extraUsageDays > container.free_days_min ? extraUsageDays - container.free_days_min : 0);
        } else if (this.rType == 'lease') {
            container.extra_usage_days_updated = extraUsageTime < 0 ? 0 : extraUsageDays > container.free_storage_days ? (extraUsageDays - (container.free_storage_days ? container.free_storage_days : 0)) : 0;
        } else {
            container.extra_usage_days_updated = 0
        }

        container.storage_charge_updated = container.do?.storage_charge * container.extra_storage_days;

        const perDiemTime = dropOffDate.getTime() - pickUpDate.getTime();
        const totalUsageDays = Math.round(Math.abs(perDiemTime / oneDay));

        if (this.rType == 'one_way') {
            const minFreeDays = container?.quote?.min_free_days;
            const minPerDiem = container?.quote?.min_per_diem;
            const maxFreeDays = container?.quote?.max_free_days;
            const maxPerDiem = container?.quote?.max_per_diem;

            if (totalUsageDays < minFreeDays) {
                container.per_diem_updated = 0;
            } else if ((minFreeDays < totalUsageDays) && (totalUsageDays < maxFreeDays)) {
                const minExtraDays = totalUsageDays - minFreeDays;
                container.per_diem_updated = Number(minExtraDays) * Number(minPerDiem);
            } else if (totalUsageDays > maxFreeDays) {
                const maxExtraDays = totalUsageDays - maxFreeDays;
                const minExtraDays = maxFreeDays - minFreeDays;
                const maxPerDiemAmount = Number(maxExtraDays) * Number(maxPerDiem);
                const minPerDiemAmount = Number(minExtraDays) * Number(minPerDiem);
                container.per_diem_updated = Number(maxPerDiemAmount) + Number(minPerDiemAmount);
            }
        } else if (this.rType == 'lease') {
            const minPerDiem = container?.quote?.per_diem_charge;
            const maxFreeDays = container?.quote?.build_down_period_days;
            const maxPerDiem = container?.quote?.post_build_down_per_diem_charge;
            const leasingPeriodDays = container?.quote?.leasing_period_days;

            if (totalUsageDays <= leasingPeriodDays) {
                container.per_diem_updated = Number(totalUsageDays) * Number(minPerDiem);
            } else if (totalUsageDays <= (leasingPeriodDays + maxFreeDays)) {
                container.per_diem_updated = Number(totalUsageDays) * Number(minPerDiem);
            } else if (totalUsageDays > (leasingPeriodDays + maxFreeDays)) {
                container.per_diem_updated = Number(totalUsageDays) * Number(maxPerDiem);
            }
        } else {
            container.per_diem_updated = 0
        }
        this.calculateTotal();
    }

    save() {
        if (this.remarks.trim() == '') {
            this.snackBar.open('Please add remarks', 'Close', {
                verticalPosition: 'top',
                duration: 5000,
            });
            return;
        }

        let updatedData = this.dataSource.data.filter((data: any) => data.pickupDateChanged || data.dropoffDateChanged);
        console.log(updatedData);

        let savePayload: any[] = [];

        updatedData.map((data: any) => {
            savePayload.push({
                do: data.do.id,
                pickup_date: data.pickup_date,
                rr: (data.dropoffDateChanged && data.original_drop_off_date && data.return_container_reference.dropoff_date) ? data.return_container_reference.return_details : null,
                dropoff_date: data.dropoffDateChanged ? data.return_container_reference.dropoff_date : null,
                requirement_container: data.requirement_container,
                remarks: this.remarks,
                og_pickup_date: data.original_pickup_date,
                og_dropoff_date: data.dropoffDateChanged ? data.original_drop_off_date : null,
                do_container_reference: data.id ?? null,
                return_container_reference: data.original_drop_off_date && data.return_container_reference.dropoff_date != null ? data.return_container_reference.id : null,
            });
        });

        this.requestService.postOpsDateChanges({
            booking: this.requestDetails.booking,
            pickup_dropoff_approvals: savePayload
        }).subscribe({
            next: response => {
                this.snackBar.open('Data Saved Successfully', 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                console.log('postQuotations', response);
                this.router.navigateByUrl(`/ops-date-change/list`)

                // this.router.navigateByUrl(`/ops-date-change/view?id=${this.request_id}&type=${this.type}&rtype=${this.rType}`);
            },
            error: err => {
                if (err.error.pickup_dropoff_approvals) {
                    const approvals = err.error.pickup_dropoff_approvals;

                    // Collect all error messages
                    let messages = approvals.map(approval => {
                        const containerKey = Object.keys(approval)[0]; // Extract container key (e.g., "HDMU6754078", "CLHU9007029")
                        return `• ${containerKey}: ${approval[containerKey][0]}`; // Format as bullet point
                    });

                    // Combine messages with line breaks for better readability
                    const finalMessage = messages.join("\n");

                    // Show the message in the dialog
                    this.openWarning(finalMessage, '', 'I Understand');
                }

                if (err.error.non_field_errors) {
                    const non_field_errors = err.error.non_field_errors;
                    // Show the message in the dialog
                    this.openWarning(non_field_errors[0], '', 'I Understand');
                }

                return this.catchError(err);
            }
        });
    }

    calculateTotal() {
        this.storageTotal = 0;
        this.storageTotalUpdated = 0;
        this.perDiemTotal = 0;
        this.perDiemTotalUpdated = 0;
        this.dataSource.data.map((data: any) => {
            this.storageTotal += data.storage_charge;
            this.storageTotalUpdated += data.storage_charge_updated;
            this.storageCurrency = data.storage_charge_currency;
            this.perDiemTotal += data.per_diem;
            this.perDiemTotalUpdated += data.per_diem_updated;
            this.perDiemCurrency = data.per_diem_currency;
        });
    }

    showDetails(data) {
        this.rowId = '';
        this.firstSlab = '';
        this.secondSlab = '';
        this.loadCommercials = true;
        let currentDate = new Date().setDate(new Date().getDate() - 1);
        const oneDay = 24 * 60 * 60 * 1000;
        const pickUpDate: any = new Date(data.pickup_date);
        const dropOffDate: any = data.return_container_reference?.dropoff_date != null ? new Date(data.return_container_reference?.dropoff_date) : new Date(currentDate);

        const perDiemTime = dropOffDate.getTime() - pickUpDate.getTime();
        const totalUsageDays = Math.round(Math.abs(perDiemTime / oneDay));

        this.timeoutId = setTimeout(() => {
            this.rowId = data.id;
            if (this.rType == 'one_way') {
                if (data.extra_usage_days_updated > data?.quote?.max_free_days) {
                    const slab1 = (Number(data?.quote?.max_free_days) - Number(data?.quote?.min_free_days)) * Number(data?.quote?.min_per_diem);
                    const slab2 = (Number(data.extra_usage_days_updated) - ((Number(data?.quote?.max_free_days) - Number(data?.quote?.min_free_days)))) * Number(data?.quote?.max_per_diem);
                    this.firstSlab = (Number(data?.quote?.max_free_days) - Number(data?.quote?.min_free_days)) + ' * ' + Number(data?.quote?.min_per_diem) + ': ' + slab1 + ' ' + data?.quote?.min_per_diem_currency;
                    this.secondSlab = (Number(data.extra_usage_days_updated) - ((Number(data?.quote?.max_free_days) - Number(data?.quote?.min_free_days)))) + ' * ' + Number(data?.quote?.max_per_diem) + ': ' + slab2 + ' ' + data?.quote?.min_per_diem_currency;
                } else {
                    const slab1 = (Number(data?.quote?.min_free_days) - Number(data.extra_usage_days_updated)) * Number(data?.quote?.min_per_diem) + ' ' + data?.quote?.min_per_diem_currency;
                    this.firstSlab = (Number(data?.quote?.min_free_days) - Number(data.extra_usage_days_updated)) + ' * ' + Number(data?.quote?.min_per_diem) + ': ' + slab1;
                }
            } else if (this.rType == 'lease') {
                const minPerDiem = data?.quote?.per_diem_charge;
                const slab1 = Number(totalUsageDays) * Number(minPerDiem);
                this.firstSlab = Number(totalUsageDays) + ' * ' + Number(minPerDiem) + ': ' + slab1 + ' ' + data?.quote?.per_diem_charge_currency;
            }
            this.loadCommercials = false;
        }, 100);
    }

    cancelSubscription() {
        this.rowId = '';
        clearTimeout(this.timeoutId);
        this.loadCommercials = false;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filterPredicate = (data: any, filter) => {
            return data.container?.container_number.toLowerCase().includes(filter) ||
                data.do_reference_no.toLowerCase().includes(filter) ||
                data.pickup_depot?.display_name.toLowerCase().includes(filter) ||
                data.return_container_reference?.dropoff_depot?.display_name.toLowerCase().includes(filter) ||
                data.return_container_reference?.return_reference_no.toLowerCase().includes(filter);
        };
        this.dataSource.filter = filterValue;
    }

    protected readonly String = String;
    errorObj: any = {};

    catchError(error) {
        if (error.status >= 500) {
            this.snackBar.open("Something went wrong! PLease try again later.", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
            return error;
        } else if
        (error.status > 399 && error.status < 500) {
            this.errorObj = {...error.error.pickup_dropoff_approvals};
            console.log(error.status, error.statusText, error);
            console.debug("error object", this.errorObj);
            return error;
        }
    }

    getErrorForContainer(element: any) {
        if (!element?.container?.container_number || !this.errorObj) {
            return null;
        }

        const containerNumber = element?.container?.container_number;
        return this.errorObj.find((error: any) => error.pickup_date?.[containerNumber])?.pickup_date?.[containerNumber] || null;
    }

    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });
    }
}
